import { useState } from 'react';
import { FormTemplate } from '@dealstack/frontend/app/pages/Project/MIP/MIPCreate/KYCRequirements/KYCDocuments/useKYCDocumentsController.ts';
import { useDownloadedFileBlob } from '@dealstack/frontend/shared/modules/document/file/hooks/useDownloadedFileBlob';
import { useParams } from 'react-router-dom';

export const useKycDocumentCardController = (formTemplate: FormTemplate) => {
	const { dealId, organizationId } = useParams();
	const { data: file } = useDownloadedFileBlob({
		fileId: formTemplate.fileId ?? '',
		dealId,
		organizationId,
	});

	const [showEditDrawer, setShowEditDrawer] = useState(false);
	const [showDocumentPreview, setShowDocumentPreview] = useState(false);

	const onPreviewDocument = () => {
		if (showDocumentPreview) {
			return;
		}
		setShowDocumentPreview(true);
	};

	return {
		onPreviewDocument,
		showEditDrawer,
		setShowEditDrawer,
		showDocumentPreview,
		setShowDocumentPreview,
		fileBlob: file?.blob,
	};
};
